// @workflow tasks.show-in-3d
/**
 * Which board viewer a set of task tags opens in: the shared task resolver
 * (tagSpatialNavigation.js `resolveTaskSpatialIntent`, intent 'task-focus'), the same rule the
 * task cards, copy links and share intents use. 360 when it plans a 360 view here, else 3D.
 */
import { resolveTaskSpatialIntent } from '@/features/Tags/utils/tagSpatialNavigation';
import { TASK_VIEWER_TAB } from './taskContract';

const TASK_FOCUS_INTENT = 'task-focus';
const PLAN_KIND_VIEWER = 'viewer';
const PLAN_VIEWER_360 = '360';

/** The facility on screen and the 360 scans it has loaded, as the resolver reads them. */
export function taskSpatialContext(store) {
  return {
    currentFacilityId: store.state.assetId,
    currentFacilityImageIds: (store.state.projects || [])
      .flatMap((project) => project.images || [])
      .map((image) => image.id),
    intent: TASK_FOCUS_INTENT,
  };
}

/** The resolver's plan for these tags in the facility on screen. */
export function taskSpatialPlan(store, tags) {
  return resolveTaskSpatialIntent(tags, taskSpatialContext(store));
}

/** Is this plan a 360 view? */
export const isPanoramaPlan = (plan) => plan.kind === PLAN_KIND_VIEWER && plan.viewer === PLAN_VIEWER_360;

/** @returns {string} the TASK_VIEWER_TAB the board opens on for these tags */
export function targetTabFor(store, tags) {
  return isPanoramaPlan(taskSpatialPlan(store, tags)) ? TASK_VIEWER_TAB.PANORAMA : TASK_VIEWER_TAB.MODEL_3D;
}
